<template>
  <a :href="to"><slot /></a>
</template>
<script setup lang="ts">
defineProps<{
  to: string;
}>();
</script>
